var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgValidationStandardEnterprise = function SvgValidationStandardEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Validation_standard_enterprise_svg__Validation_standard_enterprise_svg__cls-3{fill:#a61fe0;fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Validation_standard_enterprise_svg__Validation_standard_enterprise_svg__Validation_segmentation_standard_enterprise"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#a61fe0",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Validation_standard_enterprise_svg__Validation_standard_enterprise_svg__cls-3",
    d: "M28 11H12a2.006 2.006 0 00-2 2v14a2.006 2.006 0 002 2h16a2.006 2.006 0 002-2V13a2.006 2.006 0 00-2-2zm0 16H12V13h16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Validation_standard_enterprise_svg__Validation_standard_enterprise_svg__cls-3",
    d: "M27.41 18.42L25.99 17l-3.17 3.17-1.41-1.42L20 20.16 22.82 23l4.59-4.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15h5v2h-5zm0 4h5v2h-5zm0 4h5v2h-5z",
    fill: "#a61fe0"
  }))));
};
export default SvgValidationStandardEnterprise;